import { ContentSection } from '@/layouts/content-section/component';
import { Accordion } from '@mantine/core';
import { useMemo } from 'react';
import { AccordionLocation } from '../../../../backend/src/types.generated';
import { useAccordionItemsQuery } from './graphql.generated';
import styles from './styles.module.css';

export interface Props {
	title?: string;
	accordionLocation: AccordionLocation;
	council?: string | null;
	additionalItems?: React.ReactNode;
	additionalItemsDefaultValue?: string;
	rootClassName?: string;
}

export const CurbyAccordion = (props: Props) => {
	const {
		title,
		additionalItems,
		additionalItemsDefaultValue,
		accordionLocation,
		council,
		rootClassName,
	} = props;
	const { data } = useAccordionItemsQuery({
		variables: { location: accordionLocation!, council: council },
		skip: !accordionLocation,
	});

	const items = useMemo(() => {
		if (!data) return [];
		const councilRecords = council ? (data.council ?? []) : [];
		const allRecords = data.all ?? [];
		const union = councilRecords.concat(allRecords).filter((item) => item !== null);
		return union.sort((a, b) => a.itemOrder - b.itemOrder);
	}, [council, data]);
	const defaultValue = additionalItemsDefaultValue ?? items.find((item) => item?.isExpanded)?.id;

	if (items.length === 0) {
		return null;
	}

	return (
		<ContentSection title={title} className={rootClassName}>
			<Accordion
				defaultValue={defaultValue}
				variant="contained"
				w="100%"
				className={styles.accordion}
			>
				{additionalItems}
				{items.map((item) => (
					<Accordion.Item key={item?.id} value={item?.id ?? ''} className={styles.accordionItem}>
						<Accordion.Control className={styles.accordionControl}>{item?.title}</Accordion.Control>
						<Accordion.Panel>
							<pre className={styles.pre}>{item?.content}</pre>
						</Accordion.Panel>
					</Accordion.Item>
				))}
			</Accordion>
		</ContentSection>
	);
};
